






/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// CHECKCUSTOMEREXISTFORPHONEREGISTER
// CHECKCUSTOMEREXISTFORPHONEREGISTER
const CHECKCUSTOMEREXISTFORPHONEREGISTER= createAsyncThunk(
  "checkCustomerExistPhoneForRegister/checkCustomerExistPhoneForRegister",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const checkCustomerExistPhoneForRegisterSlice = createSlice({
  name: "checkCustomerExistPhoneForRegisterSlice",
  initialState: {
    checkCustomerExistPhoneForRegister: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfcheckCustomerExistPhoneForRegister: (state) => {
        state.checkCustomerExistPhoneForRegister.loading = false
        state.checkCustomerExistPhoneForRegister.error = false
        state.checkCustomerExistPhoneForRegister.data = []
        state.checkCustomerExistPhoneForRegister.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(CHECKCUSTOMEREXISTFORPHONEREGISTER.fulfilled, (state, action) => {
      state.checkCustomerExistPhoneForRegister = {
        ...state.checkCustomerExistPhoneForRegister,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CHECKCUSTOMEREXISTFORPHONEREGISTER.pending, (state, action) => {
      state.checkCustomerExistPhoneForRegister = {
        ...state.checkCustomerExistPhoneForRegister,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CHECKCUSTOMEREXISTFORPHONEREGISTER.rejected, (state, action) => {
      state.checkCustomerExistPhoneForRegister = {
        ...state.checkCustomerExistPhoneForRegister,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const checkCustomerExistPhoneForRegisterAction = {
    CHECKCUSTOMEREXISTFORPHONEREGISTER,
};

export { checkCustomerExistPhoneForRegisterAction };
export default checkCustomerExistPhoneForRegisterSlice.reducer;
export const {setInitialStateOfcheckCustomerExistPhoneForRegister} = checkCustomerExistPhoneForRegisterSlice.actions